import { createContext } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('mi_jpm_token')}` } });

export const tiendaApi = {
  invitado: false,
  productos: () => axios.get(`${API_URL}/api/tienda/portal/productos`, auth()),
  producto: (id) => axios.get(`${API_URL}/api/tienda/portal/productos/${id}`, auth()),
  crearPedido: (datos) => axios.post(`${API_URL}/api/tienda/portal/pedidos`, datos, auth()),
  reportarPago: (ordenId, form) => axios.post(`${API_URL}/api/tienda/portal/pedidos/${ordenId}/reportar-pago`, form, auth()),
};

// Tienda pública (sin cuenta): el token del pedido permite reportar el pago desde el mismo navegador
const publico = (ruta) => `${API_URL}/api/tienda/publico${ruta}`;
const claveToken = (ordenId) => `tienda_pago_${ordenId}`;

export const tiendaPublicaApi = {
  invitado: true,
  productos: () => axios.get(publico('/productos')),
  producto: (id) => axios.get(publico(`/productos/${id}`)),
  crearPedido: async (datos) => {
    const r = await axios.post(publico('/pedidos'), datos);
    sessionStorage.setItem(claveToken(r.data.orden_id), r.data.token_pago);
    return r;
  },
  reportarPago: (ordenId, form) => {
    form.append('token', sessionStorage.getItem(claveToken(ordenId)) || '');
    return axios.post(publico(`/pedidos/${ordenId}/reportar-pago`), form);
  },
};

export const TiendaApi = createContext(tiendaApi);

export const imgSrc = (url) => (url && url.startsWith('/api/') ? `${API_URL}${url}` : url);

export const cop = (valor) => `$${Math.round(valor || 0).toLocaleString('es-CO')}`;

export const errorApi = (e, porDefecto) => {
  const detalle = e?.response?.data?.detail;
  if (typeof detalle === 'string') return detalle;
  if (Array.isArray(detalle)) return 'Revisa los datos ingresados';
  return porDefecto;
};

export const normalizarTexto = (grupo, valor) => {
  let v = grupo.mayusculas ? valor.toUpperCase() : valor;
  if (grupo.solo_letras) v = v.replace(/[^A-Za-zÑñ]/g, '');
  return v.slice(0, grupo.max_caracteres);
};

export const faltaEnGrupo = (grupo, sel) => {
  if (!grupo.obligatorio) return false;
  return grupo.tipo === 'texto' ? !(sel?.texto || '').trim() : !(sel?.opcion_ids || []).length;
};

// Tela y manga elegidas: la vista del bordado usa la tela y con manga corta no se ofrece el puño
export const contextoCamisa = (grupos, sel) => {
  const elegida = (patron) => {
    const g = grupos.find(x => x.tipo !== 'texto' && patron.test(x.nombre));
    return g?.opciones.find(o => (sel[g.id]?.opcion_ids || []).includes(o.id));
  };
  const tela = elegida(/tela/i);
  return { tela: tela?.imagen_url || null, telaNombre: tela?.titulo || '', mangaCorta: /corta/i.test(elegida(/manga/i)?.titulo || '') };
};

// Con manga corta no hay puño: el grupo «Puños» desaparece del recorrido
export const esGrupoPunos = (g) => g.tipo !== 'texto' && /pu[ñn]o/i.test(g.nombre);

export const gruposVisibles = (grupos, sel) => (contextoCamisa(grupos, sel).mangaCorta ? grupos.filter(g => !esGrupoPunos(g)) : grupos);

export const faltaDatoComprador = (c) => {
  if (c.nombre.trim().length < 3) return 'Escribe tu nombre completo';
  const digitos = c.telefono.replace(/\D/g, '');
  if (!/^\+?[\d\s\-().]+$/.test(c.telefono.trim()) || digitos.length < 7 || digitos.length > 15) return 'Escribe un número de celular válido';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c.correo.trim())) return 'Escribe un correo electrónico válido';
  if (c.numero_documento.trim().length < 4) return 'Escribe tu número de documento';
  return null;
};

export const bordadoElegido = (grupo, valor, mangaCorta) => {
  const lugares = (grupo.ubicaciones || []).filter(u => !(mangaCorta && u.id === 'puno'));
  const colores = grupo.colores_hilo || [];
  return {
    ubicacion: lugares.find(u => u.id === valor?.ubicacion) || lugares[0] || null,
    color: colores.find(c => c.nombre === valor?.color_hilo) || colores[0] || null,
  };
};

export const TemaTienda = createContext(false);
